/**
 * OutlineFilter, originally by mishaa
 * http://www.html5gamedevs.com/topic/10640-outline-a-sprite-change-certain-colors/?p=69966
 * http://codepen.io/mishaa/pen/emGNRB
 *
 * @class
 * @param thickness {number} The tickness of the outline. Make it 2 times more for resolution 2
 * @param color {number} The color of the glow.
 *
 * @example
 *  someSprite.shader = new OutlineFilter(9, 0xFF0000);
 */
function OutlineFilter(thickness, color) {
	thickness = thickness || 1;
	PIXI.Filter.call(this,
		// vertex shader
		'attribute vec2 aVertexPosition;'
		+ 'attribute vec2 aTextureCoord;'

		+ 'uniform mat3 projectionMatrix;'
		+ 'varying vec2 vTextureCoord;'

		+ 'void main(void){'
		+ 'gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);'
		+ 'vTextureCoord = aTextureCoord;'
		+ '}',
		// fragment shader
		( 'varying vec2 vTextureCoord;'
			+ 'uniform sampler2D uSampler;'

			+ 'uniform float thickness;'
			+ 'uniform vec4 outlineColor;'
			+ 'uniform vec4 filterArea;'
			+ 'uniform vec4 filterClamp;'
			+ 'vec2 px = vec2(1.0 / filterArea.x, 1.0 / filterArea.y);'

			+ 'void main(void) {'
			+ 'const float PI = 3.14159265358979323846264;'
			+ 'vec4 ownColor = texture2D(uSampler, vTextureCoord);'
			+ 'vec4 curColor;'
			+ 'float maxAlpha = 0.;'
			+ 'vec2 displaced;'
			+ 'for (float angle = 0.; angle < PI * 2.; angle += %THICKNESS% ) {'
			+ 'displaced.x = vTextureCoord.x + thickness * px.x * cos(angle);'
			+ 'displaced.y = vTextureCoord.y + thickness * px.y * sin(angle);'
			+ 'curColor = texture2D(uSampler, clamp(displaced, filterClamp.xy, filterClamp.zw));'
			+ 'maxAlpha = max(maxAlpha, curColor.a);'
			+ '}'
			+ 'float resultAlpha = max(maxAlpha, ownColor.a);'
			+ 'gl_FragColor = vec4((ownColor.rgb + outlineColor.rgb * (1. - ownColor.a)) * resultAlpha, resultAlpha); '
			+ '}' ).replace(/%THICKNESS%/gi, (1.0 / thickness).toFixed(7))
	);

	this.uniforms.thickness = thickness;
	this.uniforms.outlineColor = new Float32Array([0, 0, 0, 1]);
	if (color)
		this.color = color;

}

OutlineFilter.prototype = Object.create(PIXI.Filter.prototype);
OutlineFilter.prototype.constructor = OutlineFilter;
module.exports = OutlineFilter;

Object.defineProperties(OutlineFilter.prototype, {
	color: {
		get: function () {
			return PIXI.utils.rgb2hex(this.uniforms.outlineColor);
		},
		set: function (value) {
			PIXI.utils.hex2rgb(value, this.uniforms.outlineColor);
		}
	}
});